import { render, staticRenderFns } from "./MedicionPrevalenciaPagination.vue?vue&type=template&id=9edfbdd2&"
import script from "./MedicionPrevalenciaPagination.vue?vue&type=script&lang=js&"
export * from "./MedicionPrevalenciaPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports